module.exports = __webpack_public_path__ + "img/wallet_card1.dbb26f6d.png";